import React, { useState, useEffect, useRef } from "react";
import Matter, { Engine, Render, World, Bodies, Composite } from "matter-js";
import PlaneImg from "../../assets/images/Plane.png";
import StartingIn from "./CrashEngine/starting-in";
import {
  mapToRange,
  createGradientTexture,
  mapToRangeSmooth,
} from "../../helper/utils";

const CasinoCrashGame = ({
  start,
  clear,
  socketMultipler,
  crashFlight,
  cashedOut,
  time,
  aviatorImg,
  maxTimer,
}) => {
  const div = document.getElementById("id");

  const [windowWidth, setWindowWidth] = useState(
    div?.offsetWidth - div?.offsetWidth / 8
    // window.innerWidth > 576 ? window.innerWidth * 0.5 : window.innerWidth * 0.8
  );
  const [windowHeight, setWindowHeight] = useState(
    div?.offsetWidth / 2 //- div?.offsetWidth/5
    // window.innerWidth > 576 ? window.innerWidth * 0.4 : window.innerWidth * 0.7
  );

  const requestRef = useRef(null);

  const [multiplier, setMultiplier] = useState(1);
  const [gameStarted, setGameStarted] = useState(false);
 
  const [crashed, setCrashed] = useState(false);
 
  const canvasRef = useRef(null);
  const gameIntervalRef = useRef(null);
  const engine = useRef(Engine.create());
  const world = useRef(engine.current.world);
  const crashTime = useRef(Math.random() * 120 + 10);
  const arrowRef = useRef(null);
  const circleRef = useRef(null);

  const [render, setRender] = useState(null);
  const circleImageRef = useRef(null);
  const extraScale = useRef(null);
  let points = [];
  const [newP, setNewP] = useState([]);

  const ballRef = useRef();

  var arrow = Bodies.rectangle(0, windowHeight, 5, 6, { isStatic: true });

  const loadImageSize = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = reject;
      img.src = url;
    });
  };

  
  if (!ballRef.current) {
    const desiredWidth = 60;
    const desiredHeight = 60;
    if (aviatorImg) {
      loadImageSize(aviatorImg).then(({ width, height }) => {
        const xScale = desiredWidth / width;
        const yScale = desiredHeight / height;

        ballRef.current = Bodies.rectangle(
          // 0, windowHeight,
          -15,
          windowHeight + 25, // 50
          desiredWidth,
          desiredHeight,
          {
            isStatic: true,
            render: {
              sprite: {
                texture: aviatorImg,
                xScale,
                yScale,
              },
            },
          }
        );

        Matter.Body.setAngle(ballRef.current, -Math.PI / 6);
        World.add(world.current, ballRef.current);
      });
    } else {
      // const xScale = desiredWidth / width;
      //   const yScale = desiredHeight / height;
      ballRef.current = Bodies.rectangle(-15, windowHeight + 25, 15, 15, {
        isStatic: true,
        render: {
          sprite: {
            texture: PlaneImg,

            // texture: createGradientTexture(40), // Use the gradient as texture
            xScale: window.innerWidth > 576 ? 0.32 : 0.15,
            yScale: window.innerWidth > 576 ? 0.32 : 0.15,
          },
        },
      });
      Matter.Body.setAngle(ballRef.current, -Math.PI / 6);

      World.add(world.current, ballRef.current);
    }
  }
  // arrow.render.fillStyle = "pink"; // Set arrow color to red

  let newrender = null;
  let gameRunning = false;
 
  let adjustedX = 0;
  let adjustedY = 0;
  const pointss = [];
  const [boom, setBoom] = useState(false);

  var circle = Bodies.circle(0, windowHeight, 5, {
    isStatic: false,
    restitution: 0.8, // Makes it bouncy
    friction: 0.5,
    render: {
      // fillStyle: "green",
      sprite: {
        texture: createGradientTexture(40), // Use the gradient as texture
        xScale: 0.4,
        yScale: 0.4,
      },
    },
  });
  // World.add(world.current, circle);

  useEffect(() => {
    // Preload the image
    const img = new Image();
    img.src = PlaneImg;
    img.onload = () => {
      circleImageRef.current = img;
    };
  }, []);

  const handleCrash = () => {
  
    setTimeout(() => {
      setBoom(true);
      setTimeout(() => setBoom(false), 500); // Explosion disappears
      clearCanvas();
    }, 300);
  };

  const setupMatterJS = () => {
    // Setup Render for Matter.js

    newrender = Render.create({
      element: canvasRef.current,
      engine: engine.current,
      options: {
        width: windowWidth - 18,
        height: windowHeight,
        wireframes: false,
        background: "rgb(15, 33, 46)",
      },
    });

    newrender.options.wireframes = false;
    setRender(newrender);
    // Create arrow body as a line

    // Store arrow body in reference
    arrowRef.current = arrow;
    circleRef.current = circle;
    extraScale.current = circle;

    Render.run(newrender);
    Matter.Runner.run(engine.current);
  };

  useEffect(() => {
    if (crashFlight) {
      handleCrash();
    }
  }, [crashFlight]);

  useEffect(() => {
    if (newP.length > 0 && render.context) {
      const canvas = render.context;
      const context = render.context;
      if (!canvas || !context) return;

      const width = (canvas.width = window.innerWidth);
      const height = (canvas.height = window.innerHeight);

      const radius = 10;
      const groundY = 400;

      // Cancel any previous animation frame
      cancelAnimationFrame(requestRef.current);

      const draw = () => {
        // Clear the canvas
        context.clearRect(0, 0, width, height);

        // Draw the filled shape
        context.beginPath();
        context.moveTo(newP[0].position.x, newP[0].position.y);
        for (let i = 1; i < newP.length; i++) {
          context.lineTo(newP[i].position.x, newP[i].position.y);
        }
        context.lineTo(newP[newP.length - 1].position.x, height);
        context.lineTo(newP[0].position.x, height);
        context.closePath();

        // Gradient fill
        const gradient = context.createLinearGradient(0, 0, width, 0);
        gradient.addColorStop(0, "rgba(0, 217, 255, 0.2)");
        gradient.addColorStop(1, "rgba(5, 156, 182, 1)");
        context.fillStyle = gradient;
        context.fill();

        // Draw the upper white line
        context.beginPath();
        context.moveTo(newP[0].position.x, newP[0].position.y);
        for (let i = 1; i < newP.length; i++) {
          context.lineTo(newP[i].position.x, newP[i].position.y);
        }
        context.strokeStyle = "white";
        context.lineWidth = 5;
        context.stroke();

        // Draw circles
        context.fillStyle = "yellow";
        newP.forEach((circle) => {
          context.beginPath();
          context.arc(
            circle.position.x,
            circle.position.y,
            radius,
            0,
            Math.PI * 2
          );
          context.fill();
        });

        requestRef.current = requestAnimationFrame(draw);
      };

      // draw(); // Start animation
    } else {
      cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
    }

    return () => {
      cancelAnimationFrame(requestRef.current);
    };
  }, [false]);

  useEffect(() => {
   
    if (socketMultipler) {
      gameRunning = true;
      
      // render.context.clearRect(0, 0, windowWidth, windowHeight);
      setGameStarted(true);
      setCrashed(false);
      startGame();
    } else {
      clearCanvas();
    }
  }, [socketMultipler]);

  useEffect(() => {
    
    if (clear) {
   
      clearCanvas();
      setNewP([]);
    }
    if (!start) {
      setNewP([]);
    }
  }, [clear, start]);

  // Game start logic
  const startGame = () => {
    // clearCanvas();
    
    // render.context.clearRect(0, 0, windowWidth, windowHeight);
    // setGameStarted(true);
    // setCrashed(false);
    let currentMultiplier = socketMultipler; // from your game logic
    let previousMappedValue = socketMultipler - 0.7; // store this between frames

    const smoothY = mapToRangeSmooth(
      currentMultiplier,
      previousMappedValue,
      windowHeight
    );



    setMultiplier(mapToRange(socketMultipler, windowHeight)); // mapToRange(socketMultipler, windowHeight)

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    ctx.strokeStyle = "pink";
    ctx.lineWidth = 2;

    ctx.beginPath();
    ctx.moveTo(100, mapToRange(1.01, windowHeight)); // Start from 1.01
    ctx.lineTo(100, mapToRange(socketMultipler, windowHeight)); // End at 2.0
    ctx.stroke();
  };

  useEffect(() => {
    if (!crashTime?.current || !arrowRef?.current || !render) return;

    const position = circleRef.current?.position;
    if (!position) return;

    const canvasScaleX =
      windowWidth / (render.bounds.max.x - render.bounds.min.x);
    const canvasScaleY =
      windowHeight / (render.bounds.max.y - render.bounds.min.y);

    adjustedX = position.x * canvasScaleX;
    adjustedY = position.y * canvasScaleY;

    const angle =
      (4 * Math.PI) / 2 + (multiplier / crashTime.current) * Math.PI;
    const angleInRadians = (angle * Math.PI) / 180;
    const y = angleInRadians * position.x;

    if (position.y >= 0) {
      const boundaryLimit = windowWidth - windowWidth / 10;

      if (windowWidth - position.y <= boundaryLimit) {
        const newX = multiplier * 1;
        const newY = windowHeight - y;

        // circleRef.current.position.x = newX;
        // circleRef.current.position.y = newY;

        // console.log(multiplier, circleRef.current.position.x, newX)

        Matter.Body.setPosition(circleRef.current, { x: newX, y: newY });

        extraScale.current.position.x = newX;
        extraScale.current.position.y = newY;

        Matter.Body.setPosition(ballRef.current, {
          x: newX,
          y: newY - 10,
        });

        const staticCircle = Bodies.circle(newX - 5, newY - 5, 5, {
          isStatic: true,
          render: {
            // sprite: {
            //   texture: PlaneImg,
            // },
          },
        });

        pointss.push(staticCircle);
        setNewP((prev) => [...prev, staticCircle]);
      } else {
        const newX = multiplier * 1;
        const newY = windowHeight - y;

        extraScale.current.position.x = newX;
        extraScale.current.position.y = newY;
        extraScale.current.angle =
          (10 * Math.PI) / 2 + (multiplier / crashTime.current) * Math.PI;
      }
    }

    // Optional: Scrolling logic (you had commented)
    // const scrollSpeed = 1.2;
    // if (circleRef.current.position.y < boundaryLimit) {
    //   Matter.Render.lookAt(render, {
    //     min: { x: render.bounds.min.x + scrollSpeed, y: render.bounds.min.y },
    //     max: { x: render.bounds.max.x + scrollSpeed, y: render.bounds.max.y - scrollSpeed / 2 },
    //   });
    // }
  }, [multiplier]);

  useEffect(() => {
    // console.log("crashFlight", newP.length);
    if (newP.length > 0 && render.context !== null) {
      const canvas = render.context;
      const context = render.context;
      if (!canvas) return;
      if (!context) return;
      const width = (canvas.width = window.innerWidth);
      const height = (canvas.height = window.innerHeight);
      // Create a curved line using circle bodies
      const radius = 10;
      const spacing = 20;
      const curveHeight = 200;
      // context.clearRect(0, 0, width, height);
      // Fill the area underneath the line
      context.beginPath();
      context.moveTo(0, height);
      newP.forEach((circle, index) => {
        const { position, bounds } = circle;
        const realX = position.x;
        const realY = position.y;
        const width = bounds.max.x - bounds.min.x;
        const height = bounds.max.y - bounds.min.y;

        // console.log(circle.position.x,circle.position.y )
        context.lineTo(realX, realY);
      });

      const groundY = 400;
      const ground = Bodies.rectangle(400, groundY, 500, 10, {
        isStatic: true,
      });

      context.lineTo(width, height);
      context.closePath();
      // context.fillStyle = "rgba(0, 10, 255, 1)"; // Fill color
      context.fill();
      // Draw the circles
      // context.fillStyle = "red"; // Circle color
      newP.forEach((circle) => {
        context.beginPath();
        context.arc(
          circle.position.x,
          circle.position.y,
          radius,
          0,
          Math.PI * 2
        );
        context.fill();
      });

      let cameraOffsetY = 0;

      const draw = () => {
        // context.save(); // Save current context state
        // context.translate(0, cameraOffsetY); // Apply floating effect

        // context.clearRect(0, 0, canvas.width, canvas.height);

        // Draw circles (optional, if needed)
        context.fillStyle = "lightblue";
        newP.forEach((circle) => {
          // context.beginPath();
          // context.arc(circle.position.x, circle.position.y, 5, 0, Math.PI * 2);
          // context.fill();
        });

        // Begin path to draw filled shape
        context.beginPath();
        context.moveTo(newP[0].position.x, newP[0].position.y);
        for (let i = 1; i < newP.length; i++) {
          context.lineTo(newP[i].position.x, newP[i].position.y);
        }
        context.lineTo(newP[newP.length - 1].position.x, canvas.height);
        context.lineTo(newP[0].position.x, canvas.height);
        context.closePath();

        // Create gradient fill
        const gradient = context.createLinearGradient(
          0,
          0,
          context.canvas.width,
          0
        );
        gradient.addColorStop(0, "rgba(0, 217, 255, 0.2)"); // Light blue
        gradient.addColorStop(1, "rgba(5, 156, 182, 1)");

        // Apply fill
        context.fillStyle = gradient;
        context.fill();

        // **Add White Border to Upper Line**
        context.beginPath();
        context.moveTo(newP[0].position.x, newP[0].position.y);
        for (let i = 1; i < newP.length; i++) {
          context.lineTo(newP[i].position.x, newP[i].position.y);
        }
        context.strokeStyle = "white"; // White stroke for the upper line
        context.lineWidth = 5; // Adjust thickness as needed
        context.stroke();
      };

      let amplitude = 10; // waggle size
      let frequency = 0.001; // speed

      function animateCamera() {
        const time = Date.now();
        const offsetY = Math.sin(time * frequency) * amplitude;
        cameraOffsetY = Math.sin(time * frequency) * amplitude; // waggle up/down

        requestAnimationFrame(animateCamera);
      }
      // animateCamera();

      let startTime = performance.now(); // Get the start time

      const renderrr = () => {
        // if (timestamp - startTime < 5000) { // Stop after 5 seconds
        draw();

        requestRef.current = requestAnimationFrame(renderrr);
        // } else {
        //   console.log("Stopped after 5 seconds");
        // }
      };
      renderrr();
      // requestAnimationFrame(renderrr); // Start the animation loop

      // requestAnimationFrame(draw)
    } else {
      cancelAnimationFrame(requestRef.current);
      requestRef.current = null;
    }

    return () => {
      cancelAnimationFrame(requestRef.current);
    };
  }, [newP]);


  const drawTrajectory = (context, points) => {
    if (points.length < 2) return;

    context.lineWidth = 1;

    // Create gradient once based on canvas dimensions
    const gradient = context.createLinearGradient(
      0,
      0,
      context.canvas.width,
      context.canvas.height
    );
    gradient.addColorStop(0, "rgba(255, 0, 0, 0.8)"); // Red at bottom
    gradient.addColorStop(1, "rgba(0, 255, 0, 1)"); // Green at top

    context.beginPath();
    context.moveTo(points[0].x, points[0].y);

    // Use quadratic curves for smoother trajectory
    for (let i = 1; i < points.length - 1; i++) {
      const midX = (points[i].x + points[i + 1].x) / 2;
      const midY = (points[i].y + points[i + 1].y) / 2;
      context.quadraticCurveTo(points[i].x, points[i].y, midX, midY);
    }

    // Draw to the last point
    context.lineTo(points[points.length - 1].x, points[points.length - 1].y);

    // Close and fill the area under the trajectory
    context.lineTo(points[points.length - 1].x, context.canvas.height);
    context.lineTo(points[0].x, context.canvas.height);
    context.closePath();

    context.fillStyle = gradient;
    context.fill();
  };

  useEffect(() => {
    const existing = canvasRef.current.querySelector("canvas");
    if (existing) {
      existing.remove();
    }
    setupMatterJS();
    window.addEventListener("resize", () => {
      resizeCanvas(newrender);
    });

    return () => {
      clearInterval(gameIntervalRef.current);
      World.clear(world.current);
      if (render) {
        Render.stop(render);
      }
    };
  }, []);

  const resizeCanvas = (render) => {
    const width = windowWidth; // Subtract margin from both sides
    const height = windowHeight; // Subtract margin from both sides

    render.canvas.width = width;
    render.canvas.height = height;
    render.options.width = width;
    render.options.height = height;

    Render.lookAt(render, {
      min: { x: 0, y: 0 },
      max: { x: width, y: height },
    });
    scaleWorld(width, height);
  };

  const scaleWorld = (newWidth, newHeight) => {
    const scaleX = newWidth / windowWidth; // Assume 800 was the original width
    const scaleY = newHeight / windowHeight; // Assume 600 was the original height

    Composite.scale(engine.current.world, scaleX, scaleY, { x: 0, y: 0 });
  };

  let arrowSpeed = 5; // Set the speed at which the arrow moves
  let rotationSpeed = 0.005; // Set the rotation speed of the arrow

  function clearCanvas() {
  
    World.clear(world.current);
    // canvasRef.current = undefined;
    points = [];
    // trail.current.pop();
    // trail.current = [];
    setMultiplier(1);
    setNewP([]);
    if(circleRef.current) {
      circleRef.current.position.x = 0;
      circleRef.current.position.y = 0;
      arrowRef.current.position.x = 0;
      arrowRef.current.position.y = 0;
      circleRef.current.angle = 0;
      extraScale.current.position.x = 0;
      extraScale.current.position.y = 0;
  
    
  
      if(render) {
        const ctx = render?.context;
        ctx.clearRect(0, 0, windowWidth, windowHeight);
        document.querySelectorAll(".circle-label").forEach((el) => el.remove());
      }
     
      if (render) {
      
        const ctx = render.context;
        ctx.drawImage(circleImageRef.current, windowHeight, windowHeight, 0, 0);
        ctx.clearRect(0, 0, windowWidth, windowHeight);
        Matter.Render.lookAt(render, {
          min: { x: 0, y: 0 },
          max: { x: windowWidth, y: windowHeight },
        });
      }

    }
    
    if(ballRef.current) {
      Matter.Body.setPosition(ballRef.current, {
        x: 0,
        y: windowHeight + 50,
      });
  
      World.add(world.current, ballRef.current);
    }
   
   
  }

  const totalMarks = 10; // Number of values on the Y-axis
  const step = 0.01; // Increment step (1.01, 1.02, ...)

  const [startValue, setStartValue] = useState(1.01); // Initial start value
  const [numbers, setNumbers] = useState([]);
  const gap = windowHeight / (totalMarks - 1); // Spacing between labels

  return (
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <div>
        <div
          className=""
          style={{
            // width: windowWidth,
            margin: "auto",
            position: "relative",
          }}
        >
          {canvasRef?.current && (
            <div
              className={
                boom
                  ? "sm:text-sm-2xl md:text-md-4xl lg:text-4xl text-red-900 font-bold"
                  : "sm:text-sm-2xl md:text-md-4xl lg:text-4xl text-white font-bold"
              }
              style={{
                position: "absolute",
                background: "tranparent",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                top: "40%",
                left: "44%",
              }}
            >
              <span
                style={
                  crashFlight
                    ? {
                        width: "120px",
                        transform: "translate(0%, 50%)",
                        border: "2px solid red",
                        padding: "8px",
                      }
                    : { width: "120px", transform: "translate(0%, 50%)" }
                }
              >
                {" "}
                {crashFlight ? (
                  <span>{crashFlight?.num}❌</span>
                ) : (
                  <span>{socketMultipler?.toFixed(2)}X</span>
                )}
                
              </span>
              {time > 0 && (
                <StartingIn show={true} time={time} maxTimer={maxTimer} />
              )}
            </div>
          )}

          {canvasRef?.current && cashedOut && (
            <div
              className="text-white text-xs sm:text-sm md:text-sm bg-gray-800 p-2 rounded-lg"
              style={{
                position: "absolute",
                background: "tranparent",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                top: "25%",
                left: "47%",
              }}
            >
              <div className="absolute" style={{ width: "150px" }}>
                <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white p-2 rounded-2xl shadow-lg text-center animate-winBox">
                  <h2 className="text-xl font-bold">🏆 You Won!</h2>
                  <p className="text-md mt-2">
                    Profit:{" "}
                    <span className="font-semibold">
                      {cashedOut?.profit?.toFixed(2)} (At{" "}
                      {cashedOut?.cashoutPoint?.toFixed(2)}X)
                    </span>
                  </p>
                  <p className="text-md">
                    Wallet:{" "}
                    <span className="font-semibold">
                      {cashedOut?.wallet?.toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}

         

          <div ref={canvasRef} className="mb-4 d-flex">
          {/* {console.log(socketMultipler, clear)} */}
            <HighlightYAxis
              mainY={circleRef?.current?.position?.y}
              mHeight={windowHeight}
              value={socketMultipler}
              clear={clear}
            />

            {(windowHeight || windowWidth) && (
              <XAxis value={socketMultipler} scaleWidth={windowWidth} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const HighlightYAxis = ({ mainY, mHeight, value, clear }) => {
  const [data, setData] = useState([]);
  const [highlightValue, setHighlightValue] = useState(1.01);
  const [screenHeight, setScreenHeight] = useState(mHeight);

  useEffect(() => {
    const handleResize = () => setScreenHeight(mHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
   
   
    if (!clear) {
      // setData([]);
    }
  }, [clear]);

  useEffect(() => {
    
    if(value == 0) {
      setData([1.01, 1.02, 1.03, 1.04, 1.05, 1.06, 1.07, 1.08, 1.09, 1.10])
    }
    if(!clear && value >= 1) {

  
    // console.log({value})
    // if (value) {
    // if(value == 0) {
    //   setData([])
    // }
    // setTimeout(() => {
      let range;
      if (value == 1.0 || value == 1.0 || value == 1 || value == 0.0 || value == 0) {
        range = Array.from(
          { length: 10 },
          (_, i) => 1.05 - (10 / 2 - i) * 0.01
        );
      } else {
        range = Array.from(
          { length: 10 },
          (_, i) => value - (10 / 2 - i) * 0.01
        );
      }

      if (data.length > 0) {
        if (data[data.length - 1] <= value) {
          setData(range);
        }
      } else {
        setData(range);
      }

     
      setHighlightValue((prev) => prev + 0.01);
    // }, 500);
    }
      
    
  }, [value, clear]);

  return (
    <div
      style={{
        width: "45px",
        height: `${screenHeight}px`,
        // position: "absolute",
        // left: -10,
      }}
    >
      {/* <div
        style={{
          top: `${mainY > 50 ? mainY : mHeight / 10}px`,
          position: "absolute",
          color: "pink",
        }}
      >
        {value?.toFixed(2)}
      </div> */}

      <svg width="50px" height="100%">
        <line
          x1="22"
          x2="22"
          y1="0"
          y2="100%"
          stroke="#2F4553"
          strokeWidth="4"
        />

        {data?.map((val, index) => {
          const yPos = `${
            ((screenHeight - (val - data[0]) * screenHeight * 10) /
              screenHeight) *
            100
          }%`;

          return (
            <g key={index}>
              {/* Background Box */}
              <rect
                x={3} // Slightly before the text position
                y={`calc(${yPos} - 15px)`} // Adjust y to center with text
                width="40" // Adjust width based on text length
                height="22" // Fixed height for readability
                fill="#2F4553" // Background color
                rx="4" // Rounded corners
              />
              {/* Text */}
              <text
                className="y-axis-rect"
                x={10} // Keep it inside the rect
                y={yPos}
                fill="#FCFCFC"
                fontSize={"12px"}
                fontWeight={600}
              >
                {val?.toFixed(2)}
              </text>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

const XAxis = ({ value, scaleWidth }) => {
  const [seconds, setSeconds] = useState([]);
  const [running, setRunning] = useState(false);
  const prevValue = useRef(value); // Store previous value
  const [gap, setGap] = useState(10);

  useEffect(() => {
    // Check if the value is still changing
    if (value !== prevValue.current) {
      setRunning(true);
      prevValue.current = value;
    }

    if (value == 0 || value == 1) {
      setRunning(false);
      setSeconds([]);
    }

    // Stop updating if the value hasn't changed for some time
    const stopTimer = setTimeout(() => {
      setRunning(false);
    }, 2000); // Stops after 2 seconds of inactivity

    return () => clearTimeout(stopTimer);
  }, [value]);

  useEffect(() => {
    if (!running) return;

    const interval = setInterval(() => {
      setSeconds((prev) => {
        const newSeconds = [...prev, prev.length + 1];
        return newSeconds; // Keep only the last 5 seconds
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [running]);

  useEffect(() => {
    const y = Math.abs(scaleWidth) / 10;
    setGap(y);
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        bottom: "-30px",
        display: "flex",
        gap: `${gap}px`,
      }}
    >
      {seconds?.slice(-6)?.map((sec, index) => (
        <div
          key={index}
          style={{ minWidth: "40px", textAlign: "center", color: "white" }}
        >
          {sec}s
        </div>
      ))}
    </div>
  );
};

export default CasinoCrashGame;
